import { render, staticRenderFns } from "./TwoFaConfigurationWarningDialog.vue?vue&type=template&id=094c2be8"
import script from "./TwoFaConfigurationWarningDialog.vue?vue&type=script&lang=js"
export * from "./TwoFaConfigurationWarningDialog.vue?vue&type=script&lang=js"
import style0 from "./TwoFaConfigurationWarningDialog.vue?vue&type=style&index=0&id=094c2be8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports